import { IBrand } from "@shared/lib/types";
import { Button } from "@shared/ui/Button";
import { Avatar, Card, Flex, Typography } from "antd";
import { Building, Pen } from "lucide-react";
import styles from "./styles.module.scss";

interface Props {
  brand: IBrand;
  handleEditClick: () => void;
}

export function BrandCard({ brand, handleEditClick }: Props) {
  return (
    <Card
      title={
        <Flex align="center" gap={12}>
          <Avatar
            shape="square"
            size={32}
            icon={<Building size={18} />}
            className={styles.cardIconAvatar}
          />
          <Typography.Title level={5} className={styles.cardTitle}>
            Brand Info
          </Typography.Title>
        </Flex>
      }
      extra={
        <Button
          type="link"
          icon={<Pen size={12} />}
          onClick={() => {
            handleEditClick();
          }}
          className={styles.editButton}
        >
          Edit
        </Button>
      }
    >
      <Flex align="center" gap={24}>
        <Avatar
          shape="square"
          size={80}
          src={brand?.logoUrl}
          className={styles.brandAvatar}
        />
        <Flex vertical>
          <Typography.Title level={4} className={styles.cardTitle}>
            {brand?.name}
          </Typography.Title>
          <Typography.Text type="secondary">{brand.websiteUrl}</Typography.Text>
        </Flex>
      </Flex>
    </Card>
  );
}
